/**
 * The list of all available actions we can dispatch in our app.
 */
enum ACTION_TYPE {
  RESET_APP_STATE = "RESET_APP_STATE",
  LOG_USER_IN = "LOG_USER_IN",
  IS_PRIVILEGED_USER = "IS_PRIVILEGED_USER",
  USER_PERMISSION = "USER_PERMISSION",
  SERVRT_STATUS = "SERVRT_STATUS",
  TAB_POSITION = "TAB_POSITION",
  TERMINAL_SELECTION = "TERMINAL_SELECTION",
  LOADER_STATUS = "LOADER_STATUS",
  TERMINAL_MASTER_STATE = "TERMINAL_MASTER_STATE",
  OVERAGE_LIST_FILTER_FORM_STATE = "OVERAGE_LIST_FILTER_FORM_STATE",
  MY_ASSIGNMENT_LIST_FILTER_FORM_STATE = "MY_ASSIGNMENT_LIST_FILTER_FORM_STATE",
  EXCEPTION_SEARCH_FILTER_FORM_STATE = "EXCEPTION_SEARCH_FILTER_FORM_STATE",
  CLEARED_FILTER_FORM_STATE = "CLEARED_FILTER_FORM_STATE",
  SHORTAGES_LIST_FILTER_FORM_STATE = "SHORTAGES_LIST_FILTER_FORM_STATE",
  DAMAGE_STATUS_MASTER = "DAMAGE_STATUS_MASTER",
  ON_HAND_DELIVERY_STATUS_MASTER = "ON_HAND_DELIVERY_STATUS_MASTER",
  ON_HAND_DELIVERY_FILTER_EXCEPTION_CODE = "ON_HAND_DELIVERY_FILTER_EXCEPTION_CODE",
  OVERAGE_LIST_FILTER_DATE_STATE = "OVERAGE_LIST_FILTER_DATE_STATE",
  OVERAGE_LIST_FILTER_EXCEPTION_CODE = "OVERAGE_LIST_FILTER_EXCEPTION_CODE",
  OVERAGE_LIST_ALL_EXCEPTION_CODE = "OVERAGE_LIST_ALL_EXCEPTION_CODE",
  OVERAGE_LIST_FILTER_COMMODITY_TYPE = "OVERAGE_LIST_FILTER_COMMODITY_TYPE",
  OVERAGE_LIST_FILTER_VALUE = "OVERAGE_LIST_FILTER_VALUE",
  OVERAGE_LIST_FILTER_STATUS = "OVERAGE_LIST_FILTER_STATUS",
  SHORTAGES_STATE_MASTER = "SHORTAGES_STATE_MASTER",
  MY_ASSIGNMENT_STATUS_MASTER = "MY_ASSIGNMENT_STATUS_MASTER",
  NOTIFICATION_STATE = "NOTIFICATION_STATE",
  SHORTAGES_PAGE_STATE = "SHORTAGES_PAGE_STATE",
  DAMAGES_PAGE_STATE = "DAMAGES_PAGE_STATE",
  ON_HAND_DELIVERY_FILTER_FORM_STATE = "ON_HAND_DELIVERY_FILTER_FORM_STATE",
  ON_HAND_DELIVERY_PAGE_STATE = "ON_HAND_DELIVERY_PAGE_STATE",
  ON_HAND_DELIVERY_SORT_STATE = "ON_HAND_DELIVERY_SORT_STATE",
  OVERAGE_DATA_TABLE_PAGE_STATE = "OVERAGE_DATA_TABLE_PAGE_STATE",
  OVERAGE_DATA_TABLE_SORT_STATE = "OVERAGE_DATA_TABLE_SORT_STATE",
  SHORTAGES_SORT_STATE = "SHORTAGES_SORT_STATE",
  DAMAGES_SORT_STATE = "DAMAGES_SORT_STATE",
  SHORTAGES_LIST_FILTER_EXCEPTION_CODE = "SHORTAGES_LIST_FILTER_EXCEPTION_CODE",
  DAMAGES_FILTER_EXCEPTION_CODE = "DAMAGES_FILTER_EXCEPTION_CODE",
  PACKAGE_OPTION_MASTER = "PACKAGE_OPTION_MASTER",
  OVERAGE_ENTRY_FORM_CHANGED = "OVERAGE_ENTRY_FORM_CHANGED",
  MY_ASSIGNMENT_DATA_TABLE_SORT_STATE = "MY_ASSIGNMENT_DATA_TABLE_SORT_STATE",
  MY_ASSIGNMENT_DATA_TABLE_PAGE_STATE = "MY_ASSIGNMENT_DATA_TABLE_PAGE_STATE",
  DOC_TYPE_STATE = "DOC_TYPE_STATE",
  DAMAGES_LIST_FILTER_FORM_STATE = "DAMAGES_LIST_FILTER_FORM_STATE",
  SEARCH_EXCEPTION_SORT_STATE = "SEARCH_EXCEPTION_SORT_STATE",
  SEARCH_EXCEPTION_PAGE_STATE = "SEARCH_EXCEPTION_PAGE_STATE",
  MISDELIVERY_FILTER_FORM_STATE = "MISDELIVERY_FILTER_FORM_STATE",
  MISDELIVERY_PAGE_STATE = "MISDELIVERY_PAGE_STATE",
  MISDELIVERY_SORT_STATE = "MISDELIVERY_SORT_STATE",
  MISDELIVERY_STATUS_MASTER = "MISDELIVERY_STATUS_MASTER",
  MISDELIVERY_FILTER_EXCEPTION_CODE = "MISDELIVERY_FILTER_EXCEPTION_CODE",
  CLEARED_PAGE_STATE = "CLEARED_PAGE_STATE",
  CLEARED_SORT_STATE = "CLEARED_SORT_STATE",
  CLEARING_CODES_MASTER = "CLEARING_CODES_MASTER",
}

export default ACTION_TYPE;
